import { useQuery } from "@tanstack/react-query";
import { VideoSearchParams, videoSearch } from "common/api/unos_rad/unos_video";
import { QUERY_KEYS } from "constant/react_query";

export const useUnosVideoSearch = (searchParams?: VideoSearchParams) => {
  const { data: video } = useQuery(
    [QUERY_KEYS.UNOS_VIDEO_SEARCH, searchParams],
    async () => {
      const result = await videoSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof video !== "undefined" && video !== "" ? video : null;
  return result;
};
